// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container__18r9o","title":"Terms_title__2CHVc","meta":"Terms_meta__2Am3f","sectionDivider":"Terms_sectionDivider__2RHs9"};